import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export function useWindowDimensions(observeResize:boolean = true) {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        if(observeResize){
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
        }else{
            handleResize();
        }
    }, [observeResize]);

    return windowDimensions;
}